import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {DataService} from '../data.service';


@Injectable({
  providedIn: 'root'
})
export class ResetPasswordService extends DataService {

  private baseURI = this.publicApiUri + '/user/reset';

  constructor(http: HttpClient) {
    super(http);
    this.setUri(this.baseURI);
  }

  getUserQuestion(email: string): Observable<any> {
    this.setUri(this.publicApiUri + '/user/question/' + email);
    return this.http.get(this.publicApiUri + '/user/question/' + email);
  }
}
